/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { iProgressoItem } from '../..'

interface BarChartProps {
  id: string
  data: iProgressoItem[]
}

export const BarChart: React.FC<BarChartProps> = ({ id, data }) => {
  function GerarGrafico(): void {
    const options = {
      series: [{
        data: data.map(e => e.porcentagem)
      }],
      colors: data.map(e => {
        if (e.porcentagem < 25) return '#EB5757'
        else if (e.porcentagem < 75) return '#D9B62B'
        else if (e.porcentagem < 99) return '#6FCF97'
        return '#27AE60'
      }),
      chart: {
        type: 'bar',
        height: data.length * 60 > 120 ? data.length * 60 : 120,
        width: 1000
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val.toFixed(1) + '%'
          },
          title: {
            formatter: function (val: any) {
              return 'Progresso:'
            }
          }
        }
      },
      grid: {
        show: false
      },
      legend: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          },
          distributed: true
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -10,
        style: {
          colors: ['#000']
        },
        textAnchor: 'end',
        formatter: function (val: string) {
          return parseFloat(val).toFixed(1) + '%'
        }
      },
      xaxis: {
        labels: {
          show: false
        },
        categories: data.map(e => e.nome),
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      },
      yaxis: {
        max: 100,
        min: 0
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-${id}`} />
  )
}
